import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import TextInput from '../text-input/index';
import css from './index.scss';
import messages from './messages';
import { Cross, Tick } from '../../helpers/icon-dictionary';
import Button from '../button/index';
import RenameGroupConfirmation from '../confirmation-request/index';
import ConfirmationMessage from '../confirmation-message/index';
import { ICON_ONLY } from '../button/variants';
import withModal from '../with-modal';

class RenameGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false
        };
        this.oldName = this.props.selectedGroup.name;

        if (this.props.selectedGroup.isDefault) {
            const groupLength = this.props.selectedGroup.name.length;
            const defaultGroupIndicator = this.props.selectedGroup.name.substr(groupLength - 2, 2);

            if (defaultGroupIndicator === ' *') {
                this.oldName = this.props.selectedGroup.name.slice(0, -2);
            }
        }

        this.newName = this.oldName;
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
        this.handleOnOk = this.handleOnOk.bind(this);
        this.handleOnCloseRenameGroupConfirmationBeforeSubmit = this.handleOnCloseRenameGroupConfirmationBeforeSubmit.bind(this);
    }

    validateModel = () => {
        if (this.newName !== '') {
            if (this.props.isRenameGroupInProgress) {
                this.setState({ canSubmit: false });
            } else {
                this.setState({ canSubmit: true });
            }
        } else {
            this.setState({ canSubmit: false });
        }
    };

    handleTextInputOnChange = (event) => {
        this.newName = event.target.value;
        this.validateModel();
    };

    handleOnOk = () => {
        this.setState({ canSubmit: false });
        this.props.handleOnOk(this.newName.trim());
    };

    handleOnCloseRenameGroupConfirmationBeforeSubmit = () => {
        this.props.handleOnCancelRenameGroupConfirmationBeforeSubmit();
        this.props.handleOnCloseRenameGroupModal();
    };

    render() {
        const renameGroupComponent = (
            <div className={css.renameGroupComponent}>
                <div
                    className={css.renameGroupHeader}> {this.props.intl.formatMessage(messages.renameGroup)} </div>
                <div className={css.groupName}><TextInput
                    disabled={this.props.isRenameGroupInProgress}
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="name"
                    placeholder={this.props.intl.formatMessage(messages.groupNameLabel)}
                    value={this.newName}
                /></div>
                <div className={css.actionButtonWrapper}>
                    <Button
                        containerClassName={css.btnDanger}
                        disabled={this.props.isRenameGroupInProgress}
                        handleOnClick={this.props.handleOnCancelRenameGroupModal}
                        icon={Cross}
                        iconClassName={css.svgIconContainer}
                    />
                    <Button
                        containerClassName={css.btnSuccess}
                        disabled={!this.state.canSubmit}
                        handleOnClick={this.handleOnOk}
                        icon={Tick}
                        iconClassName={css.svgIconContainer}
                    />
                </div>
                <Button
                    containerClassName={css.buttonClose}
                    disabled={this.props.isRenameGroupInProgress}
                    handleOnClick={this.props.handleOnCloseRenameGroupModal}
                    icon={Cross}
                    variant={ICON_ONLY} />
            </div>);

        let modalComponent = '';

        if (this.props.showRenameGroupConfirmationBeforeSubmit) {
            modalComponent = (<RenameGroupConfirmation
                handleOnCancel={this.props.handleOnCancelRenameGroupConfirmationBeforeSubmit}
                handleOnClose={this.handleOnCloseRenameGroupConfirmationBeforeSubmit}
                handleOnOk={this.props.handleOnRenameGroup}
                isLoading={this.props.isRenameGroupInProgress}>
                {this.props.intl.formatMessage(messages.doYouWishTo)}
                <span className={css.highlight}> {this.oldName} </span>
                {this.props.intl.formatMessage(messages.to)}
                <span className={css.highlight}> {this.newName} </span>
                {this.props.intl.formatMessage(messages.questionMark)}
            </RenameGroupConfirmation>
            );
        }

        if (this.props.showRenameGroupConfirmationModal) {
            modalComponent = (
                <ConfirmationMessage
                    handleOnCloseModal={this.props.handleOnCloseRenameGroupConfirmation}
                    icon={Tick}>
                    {this.props.intl.formatMessage(messages.renameGroupConfirmation)}
                </ConfirmationMessage>
            );
        }

        const componentToRender =
            (this.props.showRenameGroupConfirmationBeforeSubmit || this.props.showRenameGroupConfirmationModal)
                ?
                modalComponent
                :
                renameGroupComponent;

        return (
            <div>
                {componentToRender}
            </div>
        );
    }
}

RenameGroup.propTypes = {
    selectedGroup: PropTypes.object,
    isRenameGroupInProgress: PropTypes.bool,
    handleOnOk: PropTypes.func,
    handleOnCloseRenameGroupModal: PropTypes.func,
    handleOnCancelRenameGroupModal: PropTypes.func,
    showRenameGroupConfirmationBeforeSubmit: PropTypes.bool,
    handleOnCancelRenameGroupConfirmationBeforeSubmit: PropTypes.func,
    handleOnRenameGroup: PropTypes.func,
    showRenameGroupConfirmationModal: PropTypes.bool,
    handleOnCloseRenameGroupConfirmation: PropTypes.func,
    intl: intlShape.isRequired
};

const StyledRenameGroup = injectIntl(styleable(css)(RenameGroup));
export default withModal('isActive')(StyledRenameGroup);



// WEBPACK FOOTER //
// ./app/components/rename-group/index.js